import { useMediaQuery } from '@mui/material';
import PaginationMUI from '@mui/material/Pagination';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

const Pagination = ({ actionToDispatch, store, pageSize }) => {
  const [pageNumber, setPageNumber] = useState(1);
  const dispatch = useDispatch()
  const isXsScreen = useMediaQuery((theme) => theme.breakpoints.only('xs'))
  const [count, setCount] = useState(0)

  const handleChange = (_, value) => {
    setPageNumber(value)
    dispatch(actionToDispatch({ queries: value - 1 }))
  }

  useEffect(() => {
    if (store?.summaries?.all) {
      const totalItems = store?.summaries?.all || 0
      const itemsPerPage = pageSize || store.pageSize || 10
      const itemsCount = Math.ceil(totalItems / itemsPerPage)

      setCount(itemsCount)
    }
  }, [store])

  if (count <= 1) {
    return null
  }

  return (
  <PaginationMUI
            count={count}
            page={pageNumber}
            onChange={handleChange}
            shape="rounded"
            variant="outlined"
            color="primary"
            size={isXsScreen ? 'small' : 'medium'}
            sx={styles.root}
    />
  )
}

const styles = {
  root: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    mt: '10px',
    '& ul > li > button': {
      color: '#8D8F99',
    },

    '& ul > li:not(:first-child):not(:last-child) > button:not(.Mui-selected)': {
      color: '#8D8F99',
      border: 'none',
    },

    '& ul > li:not(:first-child):not(:last-child) > button:is(.Mui-selected)': {
      color: '#FFF',
      border: 'none',
      backgroundColor: '#29CC8B',
    },
  },
}
export default Pagination
